export const getIsProfileApiLoading = (state) => state.profile.isApiLoading;
export const getProfileData = (state) => state.profile.profileData;
